export const SaleTypes = {
    PERIOD: 'sale_period',
    BATCH: 'batch'
}